import { BarChart, OpenInNew } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

const WeeklyQuotesReportModule = () => (
    <div className="col-12 col-md-6 col-lg-5 col-xl-3">
        <div className="card">
            <div className="card-body" style={{ textAlign: 'center' }}>
                <h5 className="mb-0">Weekly Quotes Report</h5>
                <BarChart color="primary" sx={{ fontSize: 50, my: 1 }} />
                <div>
                    <Button
                        component={Link}
                        to="/modules/weekly-quotes-report"
                        startIcon={<OpenInNew />}
                    >
                        Open Report
                    </Button>
                </div>
            </div>
        </div>
    </div>
);

export default WeeklyQuotesReportModule;
